// @ts-check
import { evaluateConditions } from 'components/Condition/Evalutator';
import PropertyFunction from './datasources/util/PropertyFunction';
import _ from 'lodash';
import { useMemo } from 'react';

/**
 * Determine which panels should be visible based on the panel conditions
 * @param {Panel[]} panels
 * @returns {Record<string, boolean>} - Map of panel id to visibility boolean
 */
export const usePanelsVisibility = (panels) => {
  const properties = useMemo(() =>
    _.flatMap(panels, (panel) => _.map(panel.conditions, (condition) => condition.property)),
  [panels]);

  const { assetModel } = PropertyFunction({ properties: properties });

  return useMemo(() => {
    const reported = _.reduce([...assetModel.properties, ...(assetModel.metaProperties ?? [])], (result, value) => {
      result[value['@id']] = value.reported;
      return result;
    }, {});

    return _.reduce(panels, (result, panel) => {
      if (_.isEmpty(panel.conditions)) {
        result[panel.id] = true;
        return result;
      }

      const conditions = _.map(panel.conditions, (condition) => {
        return {
          lhs: _.toNumber(reported[condition.property['@id']]),
          operator: condition.operator,
          rhs: _.toNumber(condition.value),
          logicalOperator: condition.logicalOperator
        };
      });

      result[panel.id] = evaluateConditions(conditions);
      return result;
    }, {});
  }, [assetModel.metaProperties, assetModel.properties, panels]);
};

export default usePanelsVisibility;
